module.exports = __webpack_public_path__ + "img/Helping_Hand.1b89c529.jpeg";